module.exports = __webpack_public_path__ + "img/banner-7.329388df.jpg";